import { useEffect } from "react";

export const MESSAGE_TYPES = {
	LOAD: "LOAD",
	START_TRACK: "START_TRACK",
	AVAILABLE: "AVAILABLE",
	TRACK: "TRACK",
	OPEN_OVERLAY_ORCHESTRATOR: "OPEN_OVERLAY_ORCHESTRATOR",
	CLOSE_OVERLAY_ORCHESTRATOR: "CLOSE_OVERLAY_ORCHESTRATOR",
	CLOSE_MODAL: "CLOSE_MODAL",
	SHOW_MODAL: "SHOW_MODAL",

	CLOSE_WIDGET_FULLSCREEN: "CLOSE_WIDGET_FULLSCREEN",

	UPDATE_MODE: "UPDATE_MODE",
	MODE_FULLSCREEN: "MODE_FULLSCREEN",
	MODE_INLINE: "MODE_INLINE",
	MODE_FULLSCREEN_COLLAPSED: "MODE_FULLSCREEN_COLLAPSED",

	UPDATE_PARENT_STATS: "UPDATE_PARENT_STATS",
	REQUEST_PARENT_STATS: "REQUEST_PARENT_STATS",

	RESIZE: "RESIZE",

	UNMOUNT: "UNMOUNT",

	UPDATE_REMOTE_USER: "UPDATE_REMOTE_USER",

	UPDATE_GLOBAL_STATE: "UPDATE_GLOBAL_STATE",
	REQUEST_GLOBAL_STATE: "REQUEST_GLOBAL_STATE",
	PERFORMANCE_METRIC: "PERFORMANCE_METRIC",

	PLATFORM_FETCH_CACHED_MESSAGES: "PLATFORM_FETCH_CACHED_MESSAGES",
	PLATFORM_DATA_TRANSFER: "PLATFORM_DATA_TRANSFER",
	PLATFORM_INTERNAL_REDIRECT: "PLATFORM_INTERNAL_REDIRECT",
};

const useMessage = (type, handler) => {
	useEffect(() => {
		const handleMessage = ({ data: { type: messageType, payload } }) => {
			if (messageType !== type) {
				return;
			}
			return handler(payload);
		};

		window.addEventListener("message", handleMessage);
		return () => {
			window.removeEventListener("message", handleMessage);
		};
	}, [handler, type]);
};

export default useMessage;
